import { FunctionComponent, useMemo } from 'react'
import { FaTrashAlt, FaInfoCircle } from 'react-icons/fa'
import { Grid } from '@material-ui/core'

import { MdRemoveRedEye } from 'react-icons/md'

import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'

import Pagination from 'shared/components/Pagination'
import {
  TableHead,
  TableItem,
  TableRow,
  TBody,
  THead,
} from 'shared/components/Table/styles'
import Veiculo from '../../../../domain/entities/Veiculo'
import { StyledTable, IconButtonStyle } from './styles'

export interface ITableHeaderData {
  title: string
}
interface IProps {
  handleDelete: (veiculo: Veiculo) => void
  handleDetail: (veiculo: Veiculo) => void
  handleImageModal: (id: number, protocolo: string) => void
  tableHeadItems: ITableHeaderData[]
  type: 'CAVALO' | 'CARRETA'
  total: number
  perPage: number
  setCurrentPage: (page: number) => void
  list: Veiculo[]
  currentPage?: number
}

const TablePagination: FunctionComponent<IProps> = ({
  tableHeadItems,
  type,
  total,
  perPage,
  currentPage,
  setCurrentPage,
  list,
  handleDelete,
  handleDetail,
  handleImageModal,
}) => {
  const renderItems = useMemo(
    () =>
      list &&
      !!list.length &&
      list.map(item => (
        <TableRow key={item?.id}>
          <TableItem>{item?.placa}</TableItem>
          <TableItem>{item?.frotista?.cnpj}</TableItem>
          <TableItem active={item?.ativo}>
            {item?.ativo ? (
              <span style={{ color: colors.green }}>• Ativo</span>
            ) : item.status !== 'INVALID' &&
              item.status !== 'MANUAL_REPROVAL' ? (
              <span style={{ color: colors.grayLight }}>• Inativo</span>
            ) : (
              <span style={{ color: colors.orange }}>• Pendente</span>
            )}
          </TableItem>
          <TableItem scroll={true}>
            {item.status === 'INVALID' || item.status === 'MANUAL_REPROVAL' ? (
              <Grid container style={{ maxHeight: '100%' }}>
                <Grid item xs={12}>
                  <Text size={12} style={{ maxHeight: '100%' }}>
                    {item.protocolo_ocr && (
                      <Text size={12} weight={'bold'}>
                        ({item.protocolo_ocr})
                      </Text>
                    )}
                    {item.mensagem_ocr}
                  </Text>
                  <FaInfoCircle
                    style={{ marginLeft: 5 }}
                    color={colors.blueLight}
                    onClick={() =>
                      handleImageModal(item.id, item.protocolo_ocr)
                    }
                  />
                </Grid>
              </Grid>
            ) : (
              '-'
            )}
          </TableItem>
          <TableItem>
            <IconButtonStyle
              transparent
              onClick={() => {
                if (
                  item.status !== 'INVALID' &&
                  item.status !== 'MANUAL_REPROVAL'
                ) {
                  handleDetail(item)
                }
              }}
            >
              <MdRemoveRedEye
                color={
                  (item.status === 'INVALID' ||
                    item.status === 'MANUAL_REPROVAL') &&
                  colors.grayLight
                }
              />
            </IconButtonStyle>
            <IconButtonStyle onClick={() => handleDelete(item)} transparent>
              <FaTrashAlt />
            </IconButtonStyle>
          </TableItem>
        </TableRow>
      )),
    [list, handleImageModal, handleDetail, handleDelete],
  )
  return (
    <>
      <StyledTable data={[]} type={type}>
        <THead>
          {!!tableHeadItems.length &&
            tableHeadItems?.map((item, index) => (
              <TableHead key={index}>{item?.title}</TableHead>
            ))}
        </THead>
        <TBody>{renderItems}</TBody>
      </StyledTable>
      <br />
      <Pagination
        currentPage={currentPage}
        totalRecords={total}
        recordsPerPage={perPage}
        setCurrentPage={setCurrentPage}
      />
    </>
  )
}

export default TablePagination
